(function ($) {
  "use strict";
  if (!isMobileX(760) && $(".segura-mapa").length > 0) {
    const topSpacing = 70;
    const bottomSpacing = $(".footer").outerHeight() + 70;
    $(".segura-mapa").sticky({
      topSpacing: topSpacing,
      bottomSpacing: bottomSpacing,
    });
  }
})(jQuery);
